import _ from 'lodash';
import config from '../package.json';

//-- PROFILE API CONFIG --
export const getWebinarListApi = (state: any): string => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-webinar.webinarListApi`,
    '',
  );
};
export const getCwpWebinarListApi = (state: any): string => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-webinar.webinarListApiForCwp`,
    '',
  );
};
export const getWebinarEntityCode = (state: any): string => {
  return _.get(state, `hk-emma-web-core/app.moduleConfig.emma-webinar.lob`, '');
};
export const getWebinarFeatureId = (state: any): string => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-webinar.featureId`,
    'webinar',
  ); // webinar
};

//-- FETCH RESULT --
export const getWebinarList = (state: any): Array<string> => {
  return _.get(
    state,
    `${config.name}/webinar.data.retrieveWebinarResponse`,
    [],
  );
};

//-- WEBINAR RED DOT --
export const getWebinarRedDotFlag = (state: any): boolean => {
  return _.get(state, `${config.name}/webinar.redDot`, false);
};
